module.exports = __webpack_public_path__ + "915845534490cda873cca4747dce3823.svg";